const constantsData = {
  // serverURL: "http://localhost:8090/api/",
  serverURL: "https://evoucherprint.com/api/",

  response_success_auth_failed: -1,
  successCode: 0,
  invalid_session: 2,
  deletedStatus: "DEL",
};
const privilagesURLs = {
  getprivileges: constantsData.serverURL + "privileges/listPrivileges",
  getUserPrivileges: constantsData.serverURL + "privileges/user",
  editUserPrivileges: constantsData.serverURL + "privileges/editUserPrivileges",
};


const authenticationURLs = {
  login: constantsData.serverURL + "auth/signin",
  logout: constantsData.serverURL + "auth/logout",
};
const userManagementURLs = {
  createUser: constantsData.serverURL + "users/createUser",
  getUsersList: constantsData.serverURL + "users/listUsers",
  suspendUser: constantsData.serverURL + "users/suspendUser",
  activateUser: constantsData.serverURL + "users/activateUser",
  deleteUser: constantsData.serverURL + "users/deleteUser",
};

const AdminURLs = {
  changePassword: constantsData.serverURL + "admins/changePassword",
};

export {
  constantsData,
  privilagesURLs,
  userManagementURLs,
  authenticationURLs,
  AdminURLs,
};
